import React, { useState } from "react";
import { toast } from "sonner";
import { joinWaitlist } from "@/lib/api";

const isValidEmail = (e) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e).trim());

export const WaitlistForm = ({ source = "hero", testIdPrefix = "hero" }) => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        const value = email.trim();
        if (!isValidEmail(value)) {
            toast.error("Bitte gib eine gültige E-Mail-Adresse ein.");
            return;
        }
        setLoading(true);
        try {
            const res = await joinWaitlist(value, source);
            setSuccess(true);
            toast.success(
                res.already_registered
                    ? "Du bist bereits drin."
                    : "Du bist drin.",
            );
        } catch (err) {
            const detail =
                err?.response?.data?.detail ||
                "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
            toast.error(
                Array.isArray(detail) ? "Ungültige E-Mail-Adresse." : detail,
            );
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div
                className="flex items-center gap-3 py-[18px]"
                data-testid={`${testIdPrefix}-waitlist-success`}
            >
                <span
                    className="inline-block w-[6px] h-[6px] rounded-full"
                    style={{ backgroundColor: "var(--plenum-accent)" }}
                />
                <p
                    className="text-[15px]"
                    style={{ color: "var(--plenum-text)" }}
                >
                    Auf der Liste.
                </p>
            </div>
        );
    }

    return (
        <form
            onSubmit={onSubmit}
            className="w-full"
            data-testid={`${testIdPrefix}-waitlist-form`}
            noValidate
        >
            <div
                className="flex flex-col sm:flex-row items-stretch border bg-transparent transition-colors"
                style={{
                    borderColor: "var(--plenum-line-2)",
                    borderRadius: "2px",
                }}
            >
                <label
                    htmlFor={`${testIdPrefix}-email`}
                    className="sr-only"
                >
                    E-Mail-Adresse
                </label>
                <input
                    id={`${testIdPrefix}-email`}
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    placeholder="deine@email.ch"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    data-testid={`${testIdPrefix}-waitlist-email-input`}
                    className="flex-1 bg-transparent px-5 py-[18px] text-[15px] outline-none disabled:opacity-60"
                    style={{
                        color: "var(--plenum-text)",
                    }}
                />
                <button
                    type="submit"
                    disabled={loading}
                    data-testid={`${testIdPrefix}-waitlist-submit-button`}
                    className="text-[14px] font-medium px-7 py-[18px] sm:py-[14px] sm:my-[3px] sm:mr-[3px] transition-colors disabled:opacity-60"
                    style={{
                        backgroundColor: "var(--plenum-accent)",
                        color: "var(--plenum-text)",
                        borderRadius: "2px",
                        letterSpacing: "-0.005em",
                    }}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor =
                            "var(--plenum-accent-hover)")
                    }
                    onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                            "var(--plenum-accent)")
                    }
                >
                    {loading ? "…" : "Zugang sichern"}
                </button>
            </div>
        </form>
    );
};

export default WaitlistForm;
